import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import allen__asset from "@/assets/restore/locations/allen.jpg.asset.json";
import arlington__asset from "@/assets/restore/locations/arlington.jpg.asset.json";
import austin__asset from "@/assets/restore/locations/austin.jpg.asset.json";
import dallasHighland__asset from "@/assets/restore/locations/dallas-highland-park.jpg.asset.json";
import dallasPlano__asset from "@/assets/restore/locations/dallas-plano.jpg.asset.json";
import fortWorth__asset from "@/assets/restore/locations/fort-worth.jpg.asset.json";
import houston__asset from "@/assets/restore/locations/houston.jpg.asset.json";
import sanAntonio__asset from "@/assets/restore/locations/san-antonio.jpg.asset.json";
import southLake__asset from "@/assets/restore/locations/south-lake.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Allen",
    address: "825 Watters Creek Blvd, Building M Suite 250",
    img: allen__asset.url,
    mapUrl: map("825 Watters Creek Blvd Allen TX"),
    to: "/locations/texas/allen/",
  },
  {
    name: "Arlington",
    address: "3901 Arlington Highlands Blvd, Suite 200",
    img: arlington__asset.url,
    mapUrl: map("3901 Arlington Highlands Blvd Arlington TX"),
    to: "/locations/restore-dallas/",
  },
  {
    name: "Austin",
    serviceArea: "austin",
    address: "300 Beardsley Lane, Bldg C, Suite 101",
    img: austin__asset.url,
    mapUrl: map("300 Beardsley Lane Austin TX"),
    to: "/locations/texas/austin/",
  },
  {
    name: "Dallas – Highland Park",
    address: "4514 Cole Avenue, Office #605",
    img: dallasHighland__asset.url,
    mapUrl: map("4514 Cole Avenue Dallas TX"),
    to: "/locations/texas/dallas-highland-park/",
  },
  {
    name: "Dallas – Plano",
    address: "5425 W Spring Creek, Suite 170",
    img: dallasPlano__asset.url,
    mapUrl: map("5425 W Spring Creek Plano TX"),
    to: "/locations/restore-dallas/",
  },
  {
    name: "Fort Worth",
    address: "1751 River Run, Suite 200",
    img: fortWorth__asset.url,
    mapUrl: map("1751 River Run Fort Worth TX"),
    to: "/locations/texas/fort-worth/",
  },
  {
    name: "Houston",
    serviceArea: "houston",
    address: "2929 Allen Pkwy, Suite 200",
    img: houston__asset.url,
    mapUrl: map("2929 Allen Pkwy Houston TX 77019"),
    to: "/locations/texas/houston/",
  },
  {
    name: "San Antonio",
    serviceArea: "san-antonio",
    address: "700 N St Mary's St, Suite 1400",
    img: sanAntonio__asset.url,
    mapUrl: map("700 N St Marys St San Antonio TX"),
    to: "/locations/texas/san-antonio/",
  },
  {
    name: "Southlake",
    address: "950 E State Hwy 114",
    img: southLake__asset.url,
    mapUrl: map("950 E State Hwy 114 Southlake TX"),
    to: "/locations/texas/south-lake/",
  },
];

export const Route = createFileRoute("/locations/texas/")({
  head: () => ({
    meta: [
      { title: "RESTORE Hair | Texas Hair Transplants + Hair Restoration" },
      {
        name: "description",
        content:
          "Get your hair back and RESTORE your confidence in Texas with RESTORE Hair Transplants, offering FUE & No Shave Hair Restoration. Get a free consult today!",
      },
      { property: "og:title", content: "Texas Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across Texas and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/texas/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/texas/" }],
  }),
  component: () => <StateLocationsHub stateName="Texas" h1="Texas Hair Transplants" cities={cities} />,
});